import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, House } from "@phosphor-icons/react";

// Back = real browser history (restores previous page + tab). Hidden when there's no in-app history.
export const NavButtons = ({ home = "/admin", testid = "back-to-admin" }) => {
  const navigate = useNavigate();
  const canGoBack = (window.history.state?.idx ?? 0) > 0;
  return (
    <div className="flex items-center gap-2 shrink-0" data-testid="nav-buttons">
      {canGoBack && (
        <button type="button" onClick={() => navigate(-1)} data-testid={testid} className="btn-ghost text-xs">
          <ArrowLeft size={14} /> Back
        </button>
      )}
      <Link to={home} data-testid="nav-home-btn" className="btn-ghost text-xs" title="Home">
        <House size={14} /> Home
      </Link>
    </div>
  );
};
